export const QUALIFICATION_GROUPS = ['G1', 'G1A', 'G2', 'G3']

/**
 * The qualification group (G1/G1A/G2/G3) to show in the UPLOAD cell instead of the upload icon,
 * or null when the plain icon should be rendered. HST reports carry AHI categories, not groups.
 */
export const uploadBadge = (uploadState: string | undefined, testType?: string): string | null => {
  if (!uploadState || testType === 'HST') {
    return null
  }

  return QUALIFICATION_GROUPS.includes(uploadState) ? uploadState : null
}
